<template>
  <div class="view-options">
    <div class="search-menu-label">
      VIEW
    </div>
    <div class="view-options-holder">
      <div
          ref="gridView"
          class="grid circle"
          title="Grid View"
          @mouseup="setSearchDisplayType('grid')"
      >
        <div class="icon-size">
          <img :src="require('@/assets/svg/SVG/grid_view.svg')" class="grid-icon" />
        </div>
      </div>
      <div
          ref="listView"
          class="circle"
          title="List View"
          @mouseup="setSearchDisplayType('list')"
      >
        <div class="icon-size">
          <img :src="require('@/assets/svg/SVG/list_view.svg')" class="list-icon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {gsap} from 'gsap';
import {useRMTStore} from '@/store/RMTStore';
import {storeToRefs} from 'pinia/dist/pinia';

export default {
  name: 'ViewOptions',
  setup () {
    const RMTStore = useRMTStore();
    const { getShowCollectionSearchDisplayType, getAddCollectionSearchDisplayType, getCollectionSearchDisplayType, getEditCollectionSearchDisplayType } = storeToRefs(RMTStore);
    return {
      getShowCollectionSearchDisplayType, getEditCollectionSearchDisplayType, getAddCollectionSearchDisplayType, getCollectionSearchDisplayType, RMTStore
    };
  },
  watch: {
    searchDisplayType (to, from) {
      gsap.to(this.$refs[from + 'View'], {
        backgroundColor: 'lightgrey'
      });
      gsap.to(this.$refs[to + 'View'], {
        backgroundColor: '#afafaf'
      });
    }
  },
  computed: {
    searchDisplayType () {
      const RMTStore = useRMTStore();
      return RMTStore.getSearchDisplayType;
    },
  },
  methods: {
    setSearchDisplayType (type) {
      this.RMTStore.setSearchDisplayType(type);
    },
  }
};

</script>

<style scoped>

.view-options-holder {
  height: 30px;
  display: flex;
}

.circle {
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  background-color: lightgrey;
  display: flex;
  align-items: center;
  justify-content: center;

}

.grid {
  margin-right: 6px;
}

.grid-icon {
  width: 15px;
}

.list-icon {
  width: 15px;
}

.icon-size {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>